import React from 'react';

const ErrorComponent = ({genericError, specificError}) => (
    <div align="center" className='d-flex flex-column align-items-center justify-content-center' style={{paddingTop: '3rem'}}>
        <i className="fa fa-exclamation-triangle fa-5x text-danger shadow-lg p-3 mb-5 bg-white rounded"/>
        <div className='w-100 text-muted errorTextCalendario'>
            {genericError && <em>{genericError}</em>}
            {specificError && <em>{specificError}</em>}
        </div>
    </div>
);

export default ErrorComponent;
